import React, { DetailedHTMLProps, useMemo, useState } from 'react'
import { BiInfoCircle } from 'react-icons/bi'
import ReactInputMask from 'react-input-mask'


export const TelInput = React.forwardRef<HTMLInputElement, Props>( ( { textInfo ,label, important,necessary, info, oldValue, ...props }, ref ) => {

    const [phone,setPhone] = useState<string | undefined>(oldValue);

    const renderMask = useMemo(():string =>{
            if(!phone) return ""
            let replaces = ["(",")","_","-"," "];
            let phoneFormater = phone
            replaces.map(item => (
                phoneFormater = phoneFormater.replaceAll(item,"")    
            ))
            if(phoneFormater.charAt(2) === '9' ) return "(99) 9 9999-9999"
            return "(99) 9999-9999" 
    },[phone])

    return (
        <div className=''>
            <label className='flex justify-between'>
                <div className='flex items-center'>
                    {label}
                    {important &&  <div className='cursor-help' title={textInfo}>
                                <BiInfoCircle className='text-primary-dark ml-1' />
                        </div>}
                </div>
                {!necessary && <div className='text-sm italic '>opcional</div>}
            </label>
            <ReactInputMask 
                name={props.name}
                defaultValue={props.defaultValue}
                value={phone}
                onChange={e => setPhone(e.target.value)}
                mask={renderMask}
                placeholder="(00) 0000-0000"
                className="w-full focus:outline-none h-10 border px-2" />
            <div className='text-gray-500 text-sm'>{info}</div>
        </div>
    )
})

interface Props extends DetailedHTMLProps<any, HTMLInputElement> {
    label: string,
    important?: boolean,
    necessary?:boolean
    info?:string
    oldValue?:string
    textInfo?:string
}
